var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AlertService } from '@app/core/services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { OnInit, AfterViewInit } from '@angular/core';
import { RolesService, readParameterFromRouterState } from '@app/core';
import { GroupDetailsFacadeService } from '@app/access-management/state/group-details/group-details.facade';
import { map } from 'rxjs/operators';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { RoleScopeFacadeService } from '@app/access-management/state/role-scole.facade';
var RoleDetailsGroupScopesComponent = /** @class */ (function () {
    function RoleDetailsGroupScopesComponent(route, modalService, groupDetailsFacadeService, scopeFacadeService, alertService, roleService) {
        this.route = route;
        this.modalService = modalService;
        this.groupDetailsFacadeService = groupDetailsFacadeService;
        this.scopeFacadeService = scopeFacadeService;
        this.alertService = alertService;
        this.roleService = roleService;
        this.roleGroupScopesColumn = [];
        this.scopeNamesTable = [
            {
                name: 'Name',
                prop: 'name',
                flexGrow: 2
            }
        ];
        this.addScopeMode = false;
        this.roleId = readParameterFromRouterState(this.route, 'id');
        this.groupId = readParameterFromRouterState(this.route, 'groupId');
        this.groupDetailsFacadeService.initialize(this.groupId);
        this.group$ = this.groupDetailsFacadeService.groupDetails$;
        this.scopeFacadeService.initializeCategories();
        this.scopes$ = this.scopeFacadeService.categories$;
        this.roleGroupScopes$ = this.roleService.getRoleGroupScopes(this.roleId, this.groupId)
            .pipe(map(function (list) { return list.map(function (row) { return (__assign({}, row, { id: row.object_id })); }).slice(); }));
    }
    RoleDetailsGroupScopesComponent.prototype.ngOnInit = function () { };
    RoleDetailsGroupScopesComponent.prototype.ngAfterViewInit = function () {
        this.loadColumns();
    };
    RoleDetailsGroupScopesComponent.prototype.addScopes = function () {
        this.addScopeMode = true;
        this.resetSelectedValues();
    };
    RoleDetailsGroupScopesComponent.prototype.onSelectCategory = function (data) {
        this._selectedCategory = data;
    };
    RoleDetailsGroupScopesComponent.prototype.cancel = function () {
        this.addScopeMode = false;
        this.resetSelectedValues();
    };
    RoleDetailsGroupScopesComponent.prototype.resetSelectedValues = function () {
        this._selectedCategory = undefined;
        this._selectedConstraints = undefined;
    };
    RoleDetailsGroupScopesComponent.prototype.submit = function () {
        var _this = this;
        if (!this.isValid()) {
            return;
        }
        var request = {
            groups: [{ group_id: this.groupId }],
            category: this._selectedCategory,
            constraints: this._selectedConstraints
        };
        this.roleService.addGroupsToRole(this.roleId, request, this._selectedCategory).subscribe(function () {
            _this.addScopeMode = false;
            _this.alertService.success('Scope Names Added successfully');
            _this.dataTableAjax.refreshTable();
            _this.resetSelectedValues();
        }, function () {
            _this.alertService.error('Save Scope Names failed');
        });
    };
    RoleDetailsGroupScopesComponent.prototype.isValid = function () {
        return this._selectedCategory && this._selectedConstraints;
    };
    RoleDetailsGroupScopesComponent.prototype.loadColumns = function () {
        this.roleGroupScopesColumn = [
            {
                name: 'Scope',
                prop: 'object_type_name',
                flexGrow: 1
            },
            {
                name: 'Scope Name',
                prop: 'object_name',
                headerClass: 'ml-8',
                flexGrow: 2
            },
            {
                name: 'Actions',
                cellTemplate: this.actionTemplate,
                flexGrow: 1
            },
        ];
    };
    RoleDetailsGroupScopesComponent.prototype.onSelectScopeNames = function (rows) {
        this._selectedConstraints = rows.selected;
    };
    RoleDetailsGroupScopesComponent.prototype.onRemoveRow = function (row) {
        var _this = this;
        var ModalFixture = this.modalService.open(GeneralDeleteModalComponent, { centered: true, windowClass: 'no-border' });
        var modal = ModalFixture.componentInstance;
        modal.observable = this.roleService.removeRoleGrantId(this.roleId, row.grant_id);
        modal.onSuccessRemove = function () {
            _this.alertService.success('Scope Name delete succeed.');
            modal.close();
            _this.dataTableAjax.refreshTable();
        };
        modal.onFailRemove = function () {
            _this.alertService.error('Scope Name delete Failed');
        };
    };
    return RoleDetailsGroupScopesComponent;
}());
export { RoleDetailsGroupScopesComponent };



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-details/role-details-groups-tab/role-details-group-scopes/role-details-group-scopes.component.ts.pre-build-optimizer.js